import { breakpoints } from '@ui/css';
import { IconButton } from '@ui/kit';
import { PlayIcon, PauseIcon } from '@ui/kit/icons';
import { useActivityIndicator, HideFor } from '@utils/react';
import { Progressbar } from './atom.progress-bar.js';
import { loader, wrapper, iconButton, progressText } from './molecule.controls.style.js';
import { formatTime } from './util.format-time.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function Controls(props) {
  const isLoading = useActivityIndicator(props.audio.isLoading, {
    delayMs: 1000
  });
  const icon = (() => {
    if (isLoading.isActive()) {
      return {
        key: "loader",
        element: /*#__PURE__*/jsx("span", {
          className: loader
        })
      };
    }
    if (!props.audio.isPlaying) {
      return {
        key: "play",
        element: /*#__PURE__*/jsx(PlayIcon, {
          height: 16,
          fill: "none",
          stroke: "currentColor"
        })
      };
    } else {
      return {
        key: "pause",
        element: /*#__PURE__*/jsx(PauseIcon, {
          height: 16
        })
      };
    }
  })();
  const onClick = () => {
    if (props.audio.isLoading || props.audio.isPlaying) {
      props.audio.pause();
    } else {
      props.audio.resume();
    }
  };
  const progress = (props.audio.timeElapsedMs ?? 0) / (props.audio.durationMs ?? 1);
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    children: [!props.audio.didError && /*#__PURE__*/jsx(HideFor, {
      breakpoint: breakpoints.mobile,
      children: /*#__PURE__*/jsx(IconButton, {
        className: iconButton,
        icon: icon.element,
        iconKey: icon.key,
        size: "small",
        label: props.disabled ? "Log på for at høre lydklippet" : props.audio.isPlaying || props.audio.isLoading ? "Pause" : "Start afspilning af lydfil",
        onClick: onClick,
        disabled: props.disabled
      })
    }), /*#__PURE__*/jsx(Progressbar, {
      isPlaying: props.audio.isPlaying || props.audio.isLoading,
      durationMs: props.audio.durationMs ?? 0,
      progress: progress,
      resume: props.audio.resume,
      pause: props.audio.pause,
      seek: props.audio.seek,
      disabled: props.disabled || props.audio.didError
    }), /*#__PURE__*/jsxs("span", {
      className: progressText,
      children: [/*#__PURE__*/jsxs("span", {
        children: [formatTime(props.audio.timeElapsedMs || 0), " "]
      }), /*#__PURE__*/jsx("span", {
        children: formatTime(props.audio.durationMs || 0)
      })]
    })]
  });
}

export { Controls };
//# sourceMappingURL=molecule.controls.js.map
